import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import KapalService from '../../../../services/kapal/KapalService'
import MasterService from '../../../../services/master/MasterService'
import { AsyncPaginate } from 'react-select-async-paginate'
import DataTable from 'react-data-table-component'
import { FaEdit, FaEye, FaPlus, FaTrash } from 'react-icons/fa'
import ModalAddEditIkanTangkapan from './ModalAddEditIkanTangkapan'
import SweetAlert from 'react-bootstrap-sweetalert'
import JenisKomoditi from '../../../../utilities/kapal/JenisKomoditi'
import DataUmumKapal from '../../../cetak/kapal/DataUmumKapal'
import { PDFViewer } from '@react-pdf/renderer'

const ModalDataUmum = ({ showDataUmum, handleCloseDataUmum, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataInspeksi, setDataInspeksi] = useState(null)
    const [dataPemilik, setDataPemilik] = useState(null)
    const [listDataIkan, setListDataIkan] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getListKapalIkan = useCallback(async (page, size) => {
        try {
            const resDataIkan = await kapalService.listKapalIkan(dataPpmKapal.nomorAjuKapal, page - 1, size)
            setListDataIkan(resDataIkan.data.data)
            setTotalData(resDataIkan.data.totalData)
        } catch (error) {
            // setListDataIkan([])
        }
    }, [kapalService, dataPpmKapal])

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
                if (resDataInspeksi) {
                    setDataInspeksi(resDataInspeksi.data)

                    const resDataPemilik = await kapalService.getMasterKapalById(dataPpmKapal.idKapal)
                    setDataPemilik(resDataPemilik.data)

                    const resWpp = await masterService.listWpp(dataPpmKapal.daerahTangkap, null, 0, 10)
                    setValueWppOpt(resWpp.data.data)

                    setValueNamaNahkoda(dataPpmKapal.namaNahkoda)
                    setValueJumlahAbk(dataPpmKapal.jumlahAbk)
                    setValueAlatTangkap(dataPpmKapal.alatTangkap)
                    setValueLamaOperasi(dataPpmKapal.lamaOperasi)
                    setValueBbm(dataPpmKapal.beratBbm)
                    setValueAir(dataPpmKapal.beratAir)
                    setValueEs(dataPpmKapal.beratEs)

                }
            } catch (error) {

            }
            setLoading(false)
        }
        fetchAllData()
        getListKapalIkan(0, 10)
    }, [kapalService, masterService, dataPpmKapal, getListKapalIkan])

    const handleChangePage = (page) => {
        getListKapalIkan(page, size)
    }

    const handlePerRowsChange = async (size, page) => {
        getListKapalIkan(page, size)
        setSize(size)
    }

    const [valueNamaNahkoda, setValueNamaNahkoda] = useState(null)
    const onChangeNamaNahkoda = e => {
        setValueNamaNahkoda(e.target.value)
    }
    const [valueJumlahAbk, setValueJumlahAbk] = useState(null)
    const onChangeJumlahAbk = e => {
        setValueJumlahAbk(e.target.value)
    }

    async function loadOptionWpp(search, loadedOption, { page = 1 }) {
        const response = await masterService.listWpp(search, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const [valueWppOpt, setValueWppOpt] = useState(null)
    const onChangeOptionWpp = e => {
        setValueWppOpt(e)
    }

    const [valueAlatTangkap, setValueAlatTangkap] = useState(null)
    const onChangeAlatTangkap = e => {
        setValueAlatTangkap(e.target.value)
    }
    const [valueLamaOperasi, setValueLamaOperasi] = useState(null)
    const onChangeLamaOperasi = e => {
        setValueLamaOperasi(e.target.value)
    }
    const [valueBbm, setValueBbm] = useState(null)
    const onChangeValueBbm = e => {
        setValueBbm(e.target.value)
    }
    const [valueEs, setValueEs] = useState(null)
    const onChangeValueEs = e => {
        setValueEs(e.target.value)
    }
    const [valueAir, setValueAir] = useState(null)
    const onChangeValueAir = e => {
        setValueAir(e.target.value)
    }

    const columnsTangkapan = [
        {
            name: 'Jenis Ikan',
            cell: row => row['namaIkan']
        },
        {
            name: 'Bentuk',
            cell: row => row['bentuk'] === '1' ? 'Segar' : 'Beku'
        },
        {
            name: 'Berat (Kg)',
            cell: row => row['netto']
        },
        {
            name: 'Suhu (Celcius)',
            cell: row => row['suhu']
        },
        {
            name: 'Suhu Palka (Celcius)',
            cell: row => row['suhuPalka']
        },
        {
            name: 'Nilai Organoleptik',
            cell: row => row['nilaiOrganoleptik']
        },
        {
            name: 'Jenis Komoditi',
            cell: row => <JenisKomoditi id={row['idJenisKomoditi']} />
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Lihat </Tooltip>}>
                            <Button size="sm" variant="info" onClick={() => handleClickViewIkan(row)}>
                                <FaEye /> Lihat
                            </Button>
                        </OverlayTrigger>{' '}
                    </div>
                    {
                        dataPpmKapal.kodeStatus === '023' &&
                        <>
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah </Tooltip>}>
                                    <Button size="sm" variant="warning" onClick={() => handleClickEditIkan(row)}>
                                        <FaEdit /> Ubah
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Hapus</Tooltip>}>
                                    <Button size="sm" variant="danger" onClick={() => handleClickDeleteIkan(row)}>
                                        <FaTrash /> Hapus
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                        </>
                    }
                </div>
            )
        }
    ]

    const [showIkanTangkap, setShowIkanTangkap] = useState(false)
    const [isEditIkan, setIsEditIkan] = useState(false)
    const [dataIkan, setDataIkan] = useState(null)
    const handleCloseIkanTangkap = () => {
        setShowIkanTangkap(false)
    }

    const handleClickTambahIkan = () => {
        setIsEditIkan(true)
        setShowIkanTangkap(true)
    }

    const handleClickEditIkan = (row) => {
        setIsEditIkan(true)
        setDataIkan(row)
        setShowIkanTangkap(true)
    }

    const handleClickViewIkan = (row) => {
        setIsEditIkan(false)
        setDataIkan(row)
        setShowIkanTangkap(true)
    }

    const handleClickDeleteIkan = (row) => {
        // console.log(row)
        setListDataIkan(prevList => {
            console.log("Data sebelumnya:", prevList)
            const filtered = prevList.filter(item => !(item.trPpmKapalIkanPK.nomorAjuKapal === row.trPpmKapalIkanPK.nomorAjuKapal && item.trPpmKapalIkanPK.seri === row.trPpmKapalIkanPK.seri)).map((item, idx) => ({ ...item, trPpmKapalIkanPK: { nomorAjuKapal: row.trPpmKapalIkanPK.nomorAjuKapal, seri: idx + 1 } }))
            console.log("Data sesudah hapus:", filtered)
            return filtered
        })
    }

    const [showConfirmProses, setShowConfirmProses] = useState(false)
    const handleCloseConfirmProses = () => setShowConfirmProses(false)
    const handleClickConfirmProses = () => {
        setShowConfirmProses(true)
    }

    const [loadingProses, setLoadingProses] = useState(false)
    const [showProsesSuccess, setShowProsesSuccess] = useState(false)
    const [showProsesFailed, setShowProsesFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowProsesSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowProsesFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickProses = async () => {
        setLoadingProses(true)
        try {
            let dataPpmKapalNew = {
                ...dataPpmKapal,
                daerahTangkap: valueWppOpt.wpp ? valueWppOpt.wpp : dataPpmKapal.daerahTangkap,
                alatTangkap: valueAlatTangkap,
                lamaOperasi: valueLamaOperasi,
                beratBbm: valueBbm,
                beratAir: valueAir,
                beratEs: valueEs,
                tanggalInspeksi: dataInspeksi.tglInspeksi,
                kodeTrader: dataPpmKapal.kodeTrader,
                updatedBy: localStorage.getItem('userId'),
                updatedDate: new Date()
            }
            const resSaveKapalHeader = await kapalService.saveKapalHeader(dataPpmKapalNew)
            if (resSaveKapalHeader.data.kode === '200') {
                //kapal ikan
                const resDeleteIkanAll = await kapalService.deleteKapalIkanByAju(dataPpmKapal.nomorAjuKapal)
                if (resDeleteIkanAll.data.kode === '200') {
                    listDataIkan.map(async (kapalIkan) => {
                        // console.log(kapalIkan)
                        await kapalService.saveKapalIkan(kapalIkan)
                    })
                    setShowConfirmProses(false)
                    setShowProsesSuccess(true)
                } else {
                    setShowConfirmProses(false)
                    setShowProsesFailed(true)
                }
            } else {
                setShowConfirmProses(false)
                setShowProsesFailed(true)
            }
        } catch (error) {
            setShowConfirmProses(false)
            setShowProsesFailed(true)
        }
        setLoadingProses(false)
    }

    const [showPreview, setShowPreview] = useState(false)
    const handleClosePreview = () => setShowPreview(false)
    const handleClickPreview = () => {
        setShowPreview(true)
    }

    const handleClickClose = () => {
        // setHasilEvpDok([])
        // setValueCatatan('')
        // setValueKesimpulanOpt(null)
        handleCloseDataUmum()
    }


    return (
        <>
            <Modal
                show={showDataUmum}
                onHide={handleCloseDataUmum}
                size='xl'
                centered
                scrollable
                backdrop='static'
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Data Umum Kapal</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type='text' placeholder="alamat" className="form-control-sm" value={dataPpmKapal.jenisKapal === '1' ? 'Penangkap' : 'Pengangkut'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Fasilitas Pembeku</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type='text' placeholder="alamat" className="form-control-sm" value={dataPpmKapal.fasilitasPembeku === '1' ? 'Dengan alat pembeku (freezer fishing vessel)' : 'Tanpa alat pembeku (non freezer fishing vessel)'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Pemilik</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPemilik ? dataPemilik.pemilik : ''} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Nahkoda</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={valueNamaNahkoda} onChange={onChangeNamaNahkoda} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Jumlah ABK</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={valueJumlahAbk} onChange={onChangeJumlahAbk} />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Orang</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Daerah Penangkapan</Form.Label>
                                    <Col sm="8">
                                        <AsyncPaginate
                                            loadOptions={loadOptionWpp}
                                            value={valueWppOpt}
                                            getOptionLabel={(option) => option.wpp + ' - ' + option.wilayah}
                                            getOptionValue={(option) => option.wpp}
                                            additional={{
                                                page: 1
                                            }}
                                            onChange={onChangeOptionWpp}
                                            isDisabled={!isEdit}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Alat Tangkap</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Alat Tangkap" className="form-control-sm" value={valueAlatTangkap} onChange={onChangeAlatTangkap} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="5" className="control-label align-self-center mb-0" htmlFor="searchNib">Lama Operasi Penangkapan</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" className="form-control-sm" value={valueLamaOperasi} onChange={onChangeLamaOperasi} />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Hari</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Data Logistik</Form.Label>
                                    <Form.Label column sm="1" className="control-label align-self-center mb-0" htmlFor="searchNib">BBM</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="BBM" className="form-control-sm" value={valueBbm} onChange={onChangeValueBbm} />
                                    </Col>
                                    <Form.Label column sm="1" className="control-label align-self-center mb-0" htmlFor="searchNib">Es</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Es" className="form-control-sm" value={valueEs} onChange={onChangeValueEs} />
                                    </Col>
                                    <Form.Label column sm="1" className="control-label align-self-center mb-0" htmlFor="searchNib">Air</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Air" className="form-control-sm" value={valueAir} onChange={onChangeValueAir} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type='date' placeholder="Tanggal Inspeksi" className="form-control-sm" value={dataInspeksi && dataInspeksi.tglInspeksi} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Ikan Hasil Tangkapan</b></Form.Label>
                                    <Col sm="2">
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            {dataPpmKapal.kodeStatus === '023' && localStorage.getItem("role") === "7" && <Button type="button" variant="primary" size="sm" onClick={() => handleClickTambahIkan()}><FaPlus /> Tambah Data Ikan Tangkapan</Button>}
                            <div className="table-responsive border-bottom my-2">
                                {(loading && <Spinner />)}
                                {
                                    listDataIkan &&
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                        columns={columnsTangkapan}
                                        data={listDataIkan}
                                        highlightOnHover
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalData}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        persistTableHead={true}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && dataPpmKapal.kodeStatus === '023' && localStorage.getItem("role") === "7" && <Button variant="primary" size="sm" onClick={() => handleClickConfirmProses()}>Simpan</Button>}{' '}
                    {isEdit && dataPpmKapal.kodeStatus !== '023' && <Button variant='secondary' size='sm' onClick={() => handleClickPreview()}>Preview PDF</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <ModalAddEditIkanTangkapan showIkanTangkap={showIkanTangkap} handleCloseIkanTangkap={handleCloseIkanTangkap} dataPpmKapal={dataPpmKapal} dataIkan={dataIkan} listDataIkan={listDataIkan} setListDataIkan={setListDataIkan} isEdit={isEditIkan} />
            <ModalPreviewDataUmum showPreview={showPreview} handleClosePreview={handleClosePreview} dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal}/>
            {
                showConfirmProses &&
                <SweetAlert
                    title="Simpan Data Umum?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProses}
                    onCancel={handleCloseConfirmProses}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const ModalPreviewDataUmum = ({ showPreview, handleClosePreview, dataDisposisi, dataPpmKapal }) => {
    return (
        <>
            <Modal
                show={showPreview}
                onHide={handleClosePreview}
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Body>
                    <PDFViewer style={{ width: 1105, height: 800 }}>
                        <DataUmumKapal dataDisposisi={dataDisposisi} dataPpmKapal={dataPpmKapal}/>
                    </PDFViewer>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalDataUmum